import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  outreachViewModal,
  cancelscheduleNotification,
} from "DashboardOutreachAction";
import {
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  DISPLAY_LOCAL_DATE_FORMAT,
} from "Constants";
import LocaleStrings from "Languages";

class DashboardScheduledNotificationItem extends Component {
  constructor(props) {
    super(props);
  }

  viewNotification = () => {
    var { notification } = this.props;
    // console.log("notification :- ", notification);

    this.props.outreachViewModal({ show: true, values: notification });
  };

  cancelscheduledOutreach(e, notification) {
    let values = {};
    values.status = "cancelled";
    values.eventid = this.props.session.eventid;
    confirmAlert({
      title: LocaleStrings.outreach_cancel_schedule_push_title,
      message: LocaleStrings.outreach_cancel_schedule_push_subtitle,
      confirmLabel: LocaleStrings.content_ok,
      cancelLabel: LocaleStrings.content_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            var batchno = notification.batchno;
            this.props.cancelscheduleNotification(
              this.props.session,
              batchno,
              values,
              (response) => {
                if (response.success === 0) {
                  this.props.showError(
                    LocaleStrings.outreach_cancel_schedule_push_error
                  );
                } else {
                  this.props.showSuccess(
                    LocaleStrings.outreach_cancel_schedule_push_success
                  );
                  this.props.pagination(this.props.currentPage);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    var { notification } = this.props;
    let tabledate = moment(notification.schedule_time).format(
      `${DISPLAY_LOCAL_DATE_FORMAT} HH:mm`
    );

    return (
      <tr>
        <td style={{ width: "40%" }}>
          <div className="vertical-align-center">
            <div className="outreach-list-image-container">
              {notification.image ? (
                <img
                  className="w-full h-full b-radius-10"
                  src={`${BASE_IMAGES_URL}/${notification.image}?api_key=${ACCESS_FILES_API_KEY}`}
                />
              ) : (
                <svg
                  width="14"
                  height="17"
                  viewBox="0 0 14 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1070_1282)">
                    <path
                      d="M13.8316 12.1798L12.8572 10.6675C12.7609 10.5173 12.7042 10.3456 12.6924 10.1682L12.3557 5.09295C12.2863 3.78424 11.737 2.54533 10.8107 1.60796C9.88428 0.670597 8.64421 0.0989812 7.32241 3.48501e-05C5.90724 -0.07954 4.51759 0.396899 3.4561 1.32559C2.39461 2.25428 1.74727 3.56 1.65506 4.95837L1.29682 10.1788C1.28503 10.3563 1.22837 10.528 1.13203 10.6782L0.168366 12.1798C0.065047 12.3404 0.00726116 12.5255 0.0010482 12.7157C-0.00516477 12.906 0.0404233 13.0944 0.133047 13.2612C0.225671 13.4281 0.36193 13.5673 0.527581 13.6643C0.693232 13.7612 0.882192 13.8124 1.07471 13.8125H12.9217C13.1145 13.8131 13.3039 13.7623 13.4701 13.6656C13.6363 13.5689 13.773 13.4297 13.8661 13.2628C13.9591 13.0958 14.005 12.9072 13.999 12.7166C13.9929 12.5261 13.9351 12.3407 13.8316 12.1798Z"
                      fill="#7E8997"
                    />
                    <path
                      d="M8.2395 14.875C8.3646 14.8764 8.48716 14.9101 8.59498 14.9728C8.7028 15.0355 8.79214 15.1251 8.85409 15.2325C8.91604 15.34 8.94845 15.4616 8.9481 15.5853C8.94775 15.709 8.91465 15.8304 8.85209 15.9375C8.66222 16.2562 8.39148 16.5204 8.06665 16.704C7.74182 16.8876 7.37415 16.9841 6.99999 16.9841C6.62584 16.9841 6.25817 16.8876 5.93334 16.704C5.60851 16.5204 5.33777 16.2562 5.14789 15.9375C5.08533 15.8304 5.05223 15.709 5.05188 15.5853C5.05153 15.4616 5.08395 15.34 5.1459 15.2325C5.20785 15.1251 5.29718 15.0355 5.40501 14.9728C5.51283 14.9101 5.63539 14.8764 5.76048 14.875H8.2395Z"
                      fill="#7E8997"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1070_1282">
                      <rect width="14" height="17" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              )}
            </div>
            <div className="ml-10">
              <b>{notification.title}</b>
            </div>
          </div>
        </td>
        <td style={{ width: "15%" }}>
          <p className="text-capitalize">
            {notification.redirectto ? notification.redirectto : "-"}
          </p>
        </td>
        <td style={{ width: "15%" }}>{tabledate}</td>
        <td style={{ width: "15%" }}>
          {_.startCase(
            notification.status === "pending"
              ? LocaleStrings.scheduled
              : notification.status === "cancelled"
              ? LocaleStrings.cancelled
              : "-"
          )}
        </td>
        <td style={{ width: "15%" }}>
          <div>
            <button
              className="btn btn-custom-table-white"
              onClick={this.viewNotification}
            >
              {LocaleStrings.button_view}
            </button>
            {notification.status == "pending" ? (
              <button
                className="btn btn-custom-table-delete ml-10"
                onClick={(e) => this.cancelscheduledOutreach(e, notification)}
              >
                {LocaleStrings.button_cancel}
              </button>
            ) : (
              ""
              // <span className="ml-10">
              //   {LocaleStrings.outreach_cancel_schedule_push_text_no_action}
              // </span>
            )}
          </div>
        </td>
      </tr>
    );
  }
}

var mapStateToProps = (state) => ({
  session: state.session,
});

export default connect(mapStateToProps, {
  outreachViewModal,
  cancelscheduleNotification,
  showSuccess,
  showError,
})(DashboardScheduledNotificationItem);
